import { Tabs } from '@/components/molecules/tabs'
import { JapaneseResidentForm } from '@/components/organisms/checkIn/japanese-resident-form'
import { OverseasResidentForm } from '@/components/organisms/checkIn/overseas-resident-form'
import { Loading } from '@/components/organisms/loading'
import { IdentityVerifyTemplate } from '@/components/template/identity-verify-template'
import { useIdentityVerifyScreen } from '@/hooks/use-identity-verify-screen'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const IdentityVerify: React.FC = () => {
  const { t } = useTranslation()
  const screen = useIdentityVerifyScreen()

  if (screen.status !== 'ready') {
    return (
      <IdentityVerifyTemplate title={t('Identification')}>
        <Loading loading>
          <></>
        </Loading>
      </IdentityVerifyTemplate>
    )
  }

  const { hotelId, requiredIdentifyVerification, isSkippable, residence, selectResidence } = screen

  return (
    <IdentityVerifyTemplate
      title={t('Identification')}
      tabs={
        // 設定で片方だけが対象でも、ゲストはもう一方の書類で出すことを選べるようタブは常に2つ出す
        <Tabs
          items={[
            { key: 'japanese' as const, label: t('Japanese Resident') },
            { key: 'overseas' as const, label: t('Overseas Resident') },
          ]}
          active={residence}
          onChange={selectResidence}
        />
      }
    >
      {residence === 'japanese' ? (
        <JapaneseResidentForm hotelId={hotelId} requiredIdentifyVerification={requiredIdentifyVerification} isSkippable={isSkippable} />
      ) : (
        <OverseasResidentForm hotelId={hotelId} requiredIdentifyVerification={requiredIdentifyVerification} isSkippable={isSkippable} />
      )}
    </IdentityVerifyTemplate>
  )
}
